
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  ogImageUrl?: string;
  keywords?: string;
  ogType?: string;
  twitterCard?: string;
  jsonLd?: Record<string, any>;
}

const SEO = ({ 
  title = 'GoTrekking - Compare Trek Packages for Your Perfect Adventure',
  description = 'Find and compare the best trek packages from top adventure companies in India. Get detailed information on popular Himalayan treks and book your perfect adventure.',
  canonicalUrl = 'https://gotrekking.in',
  ogImageUrl = '/banner.jpg',
  keywords = 'trekking, hiking, adventure, Himalayas, trek packages, India, adventure companies',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  jsonLd
}: SEOProps) => {
  const siteTitle = 'GoTrekking';
  const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:site_name" content="GoTrekking" />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageUrl} />
      
      {/* Mobile viewport */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Structured Data JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
